module.exports = __webpack_public_path__ + "img/title-2-fa1f58.png";